module.exports = __webpack_public_path__ + "static/media/home_blue.65c8fbee.svg";